import { useHistory, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { placeOrder } from '../store/slices/app'
import { PageURLs } from '../common'

const OrderConfirmation = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { order } = useParams<{ order: string }>()

  useEffect(() => {
    if (order) {
      dispatch(placeOrder(order))
      history.replace(PageURLs.BookingReview)
    } else {
      history.replace(PageURLs.Home)
    }
  }, [])

  return null
}

export default OrderConfirmation
